import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import axios from "axios";
import toast from "react-hot-toast";
import { AdminContext } from "../../Context/AdminContext"
import logoo from "../../imges/logo.png"
import { FiAlignJustify } from "react-icons/fi";
import { BallTriangle } from 'react-loader-spinner'
import { useTranslation } from "react-i18next";

function EpinHistory() {
    const { logOut } = useContext(AdminContext);
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);
    const [searchValue, setSearchValue] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;
    let navigate = useNavigate();
    const { t, i18n } = useTranslation(); // Translation hook
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsSidebarOpen(window.innerWidth > 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSearch = async () => {
        if (!searchValue.trim()) {
            toast.error("Please enter an agent ID.");
            return;
        }

        try {
            const response = await axios.get("https://www.together-v-egp.com/api/v1/agent/E_PinsStats", {
                params: { epin: searchValue },
                withCredentials: true,
            });

            if (response?.data?.data) {
                setSearchResults(response.data.data);
                setCurrentPage(1);
            } else {
                toast.error("No results found.");
            }
        } catch (error) {
            toast.error("Error fetching data. Please try again later.");
        }
    };

    function getAgentsEPins() {
        return axios.get(`https://www.together-v-egp.com/api/v1/agent/E_PinsStats`, {
            withCredentials: true,
        });
    }

    const { data, isLoading } = useQuery("getAgentsEPins", getAgentsEPins);
    console.log(data?.data.data)
    const records = searchResults.length > 0 ? searchResults : data?.data?.data || [];
    const totalPages = Math.ceil(records.length / recordsPerPage);
    const paginatedData = records.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const handlePageChange = (page) => setCurrentPage(page);
    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const handlePreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

    useEffect(() => {
        if (i18n.language === "ar") {
            document.body.classList.add("rtl");
        } else {
            document.body.classList.remove("rtl");
        }

        // Cleanup on unmount
        return () => {
            document.body.classList.remove("rtl");
        };
    }, [i18n.language]);

    return (
        <>
            <header id="header" className="header fixed-top d-flex align-items-center">
                <Helmet>
                    <meta charset="utf-8" />
                    <meta content="width=device-width, initial-scale=1.0" name="viewport" />
                    <title>E Pins History</title>
                    <meta content="" name="description" />
                    <meta content="" name="keywords" />
                </Helmet>
                <div className="d-flex align-items-center justify-content-between w-100">
                    {/* Logo */}
                    <div>
                        <img
                            src={logoo}
                            alt="Logo"
                            className="logo d-flex align-items-center w-35"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/DashboardAdmin")}
                        />
                    </div>

                    {/* Language Toggle Buttons */}
                    <div className="d-flex">
                        <li className="nav-item dropdown bg-body">
                            <Link
                                className="nav-link "
                                to="#"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <span>{t("language")}</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item">
                                    <button
                                        className={`btn ${i18n.language === "en" ? "btn-primary" : "btn-outline-primary"} mx-1`}
                                        onClick={() => changeLanguage("en")}
                                    >
                                        English
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`btn ${i18n.language === "ar" ? "btn-primary" : "btn-outline-primary"} mx-1`}
                                        onClick={() => changeLanguage("ar")}
                                    >
                                        العربية
                                    </button>
                                </li>

                            </ul>
                        </li>

                    </div>

                    {/* Sidebar Toggle */}
                    <h2 className="menu-icon" onClick={toggleSidebar}>
                        <FiAlignJustify />
                    </h2>
                </div>
            </header>

            <aside id="sidebar" className={`sidebar ${isSidebarOpen ? "open" : "closed"} ${i18n.language === "ar" ? "sidebar-right" : ""}`}>
                <ul className="sidebar-nav" id="sidebar-nav">
                    <li className="nav-item">
                        <Link className="nav-link" to="/DashboardAdmin">
                            <i className="bi bi-grid"></i>
                            <span>{t("dashboard")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/Agents">
                            <i className="bi bi-grid"></i>
                            <span>{t("allAgents")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/NewId">
                            <i className="bi bi-grid"></i>
                            <span>{t("changeID")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/AddEpin">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("addEpin")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/EPin">
                            <i className="bi bi-grid"></i>
                            <span>E-Pins</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/EpinHistory">
                            <i className="bi bi-grid"></i>
                            <span>{t("ePinsHistory")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/AddProduct">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("addProduct")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/AllProducts">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("allProducts")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/MyTreeAdmin">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("myTree")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/AddEvent">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("addEvents")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/ViewAllEventsAdmin">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("viewEvents")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/WithDrawRequest">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("withdrawRequests")}</span>
                        </Link>
                    </li>

                    <li className="nav-item dropdown bg-body">
                        <Link
                            className="nav-link dropdown-toggle"
                            to="#"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("reports")}</span>
                        </Link>
                        <ul className="dropdown-menu">
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/MyTransfers">
                                    <i className="bi bi-box-arrow-in-down"></i>
                                    <span>{t("myTransfers")}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/AllRequestsProducts">
                                    <i className="bi bi-box-arrow-in-down"></i>
                                    <span>{t("allPurchase")}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/TransferRequests">
                                    <i className="bi bi-box-arrow-in-down"></i>
                                    <span>{t("allTransfers")}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/AllWithDrawsAdmin">
                                    <i className="bi bi-box-arrow-in-down"></i>
                                    <span>{t("allWithdraws")}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link collapsed" to="/BinaryReports">
                                    <i className="bi bi-box-arrow-in-down"></i>
                                    <span>{t("binaryDetails")}</span>
                                </Link>
                            </li>
                        </ul>
                    </li>


                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/Filtration">
                            <i className="bi bi-box-arrow-in-down"></i>
                            <span>{t("filtration")}</span>
                        </Link>
                    </li>
                    <li className="nav-heading">{t("pages")}</li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/AllContactUs">
                            <i className="bi bi-person"></i>
                            <span>{t("allContact")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/ProfileAdmin">
                            <i className="bi bi-person"></i>
                            <span>{t("profile")}</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link collapsed" onClick={() => logOut()}>
                            <i className="bi bi-person"></i>
                            <span>{t("logout")}</span>
                        </Link>
                    </li>
                </ul>
            </aside>



            <section>
                <div id="main" className="bg-light-2">
                    <div className="pagetitle">
                        <h1>{t("epins")}</h1>
                        <nav>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/">{t("home")}</a>
                                </li>
                                <li className="breadcrumb-item">{t("dashboard")}</li>
                                <li className="breadcrumb-item active">{t("epins")}</li>
                            </ol>
                        </nav>
                    </div>

                    <div className="search-bar mb-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Epin"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                        <button className="btn btn-primary mt-2" onClick={handleSearch}>
                            {t("search")}
                        </button>
                    </div>

                    <div className="p-4 rounded-1 bg-white shadow-3 booking">
                        <div>
                            {isLoading ? (
                                <div className="w-100 py-5 d-flex justify-content-center">
                                    <BallTriangle
                                        height={100}
                                        width={100}
                                        radius={5}
                                        color="#4fa94d"
                                        ariaLabel="ball-triangle-loading"
                                        wrapperStyle={{}}
                                        visible={true}
                                    />
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                        <table className="table col-12">
                                            <thead className="bg-light-2">
                                                <tr>
                                                    <th>{t("agentId")}</th>
                                                    <th>{t("agentName")}</th>
                                                    <th>{t("registeredParentId")}</th>
                                                    <th>{t("registeredParentName")}</th>
                                                    <th>{t("phone")}</th>
                                                    <th>{t("code")}</th>
                                                    <th>{t("status")}</th>
                                                    <th>{t("createdAt")}</th>
                                                    <th>{t("expiredAt")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedData.map((epin, index) => (
                                                    <tr key={epin?._id || index}>
                                                        <td>{epin?.agentId?.id || t("na")}</td>
                                                        <td>
                                                            {epin?.agentId?.firstName || t("na")}{" "}
                                                            {epin?.agentId?.lastName || t("na")}
                                                        </td>
                                                        <td>
                                                            {epin?.agentId?.registeredParent.id || t("na")}
                                                        </td>
                                                        <td>
                                                            {epin?.agentId?.registeredParent.firstName || t("na")}{" "}
                                                            {epin?.agentId?.registeredParent.lastName || t("na")}
                                                        </td>
                                                        <td>{epin?.agentId?.phone || t("na")}</td>
                                                        <td>{epin?.code || t("na")}</td>
                                                        <td>{epin?.status || t("na")}</td>
                                                        <td>
                                                            {epin.createdAt
                                                                ? epin.createdAt.split("T")[0]
                                                                : t("na")}
                                                        </td>
                                                        <td>
                                                            {epin.expiredDate
                                                                ? epin.expiredDate.split("T")[0]
                                                                : t("na")}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-flex justify-content-center align-items-center mt-4">
                                        {/* First Page Button */}


                                        {/* Previous Button */}
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handlePreviousPage}
                                            disabled={currentPage === 1}
                                        >
                                            {t("previous")}
                                        </button>

                                        {/* Page Numbers with Ellipsis */}
                                        {[...Array(totalPages)].map((_, page) => {
                                            const pageNumber = page + 1;

                                            // Logic to show first, last, and surrounding pages only
                                            if (
                                                pageNumber === 1 || // Always show first page
                                                pageNumber === totalPages || // Always show last page
                                                (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1) // Show current +/- 1
                                            ) {
                                                return (
                                                    <button
                                                        key={pageNumber}
                                                        onClick={() => handlePageChange(pageNumber)}
                                                        className={`btn mx-1 ${currentPage === pageNumber ? "btn-success" : "btn-outline-primary"}`}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                );
                                            } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
                                                // Add ellipsis for skipped pages
                                                return (
                                                    <span key={`ellipsis-${pageNumber}`} className="mx-1">
                                                        ...
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })}

                                        {/* Next Button */}
                                        <button
                                            className="btn btn-primary ms-2"
                                            onClick={handleNextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            {t("next")}
                                        </button>


                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>



        </>
    );
}

export default EpinHistory;
